import type { PageGrounding } from './grounding';

/**
 * GENERATED from the live guide articles (Sep 23, 2026) by the Labs grounding scripts. Do not
 * hand-edit. Skills: what the article's first-round description names, then its skills chart,
 * filtered to its role family. `processLine` paraphrases only the article's interview section.
 */
export const PAGES: Record<string, PageGrounding> = {
  'advent-international-internship-guide': {
    family: 'finance',
    processLine:
      "Advent's first round is a 30-45 minute phone screen: resume, why PE, why Advent, and basic LBO and valuation questions.",
    skills: ['valuation', 'financial-modeling'],
  },
  'affirm-internship-guide': {
    family: 'software',
    processLine:
      "Affirm's first conversation is a 30-minute non-technical recruiter screen, after a 60-minute coding assessment.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'airbnb-internship-guide': {
    family: 'software',
    processLine: 'Airbnb starts with a 30-minute recruiter screen, after a mandatory CodeSignal coding assessment.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'akuna-capital-internship-guide': {
    family: 'finance',
    processLine:
      "Akuna's technical phone interview is one-on-one with a trader or engineer, after math and coding tests.",
    skills: ['coding-fundamentals', 'quant-reasoning'],
  },
  'albertsons-internship-guide': {
    family: 'other',
    processLine:
      'Albertsons interviews lean behavioral: a recruiter screen, then a one-on-one with the hiring manager.',
    skills: ['communication', 'sql-data'],
  },
  'anheuser-busch-inbev-internship-guide': {
    family: 'operations',
    processLine: "AB InBev's first interview is a 15-45 minute call: resume walkthrough and behavioral questions.",
    skills: ['case-structure', 'operations'],
  },
  'anthropic-internship-guide': {
    family: 'ai-ml',
    processLine:
      "Anthropic's first live round is a 90-minute coding screen with an engineer, after a CodeSignal assessment.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'ares-management-internship-guide': {
    family: 'finance',
    processLine:
      'Ares starts with a 15-30 minute recruiter screen on motivation, why alternatives, and which business group you want.',
    skills: ['communication', 'case-structure'],
  },
  'armanino-internship-guide': {
    family: 'accounting-firm',
    processLine:
      'Armanino starts with a 20-30 minute recruiter call on your background, interest in the firm, and CPA eligibility.',
    skills: ['tax', 'accounting'],
  },
  'asana-internship-guide': {
    family: 'software',
    processLine:
      "Asana's first interview is a collaborative, IDE-based coding call with a senior engineer or hiring manager.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'astrazeneca-internship-guide': {
    family: 'other',
    processLine: 'AstraZeneca opens with an on-demand HireVue of behavioral and motivational questions.',
    skills: ['communication', 'sql-data'],
  },
  'atlassian-internship-guide': {
    family: 'software',
    processLine:
      "Atlassian's first conversation is a 30-minute recruiter screen, after a HackerRank coding assessment.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'attentive-internship-guide': {
    family: 'software',
    processLine: 'Attentive starts with a 30-minute recruiter screen on your goals and one project you built.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'bain-capital-internship-guide': {
    family: 'finance',
    processLine: "Bain Capital's first round is two 30-minute Zoom sessions, one of them a case study.",
    skills: ['case-structure', 'markets'],
  },
  'bates-white-internship-guide': {
    family: 'consulting',
    processLine:
      "Bates White's first round is virtual: behavioral questions plus a case of brainstorming, calculations and discussion.",
    skills: ['case-structure', 'quant-reasoning'],
  },
  'bbdo-internship-guide': {
    family: 'marketing',
    processLine:
      'BBDO starts with a 15-20 minute recruiter screen on motivation, cultural fit and basic qualifications.',
    skills: ['consumer-insight', 'marketing-strategy'],
  },
  'bcg-internship-guide': {
    family: 'consulting',
    processLine:
      "BCG's first round is two 45-minute interviews, each part behavioral and part case, after the Casey chatbot.",
    skills: ['case-structure', 'sql-data'],
  },
  'berkshire-hathaway-internship-guide': {
    family: 'other',
    processLine:
      'Berkshire interviews usually run 1-2 rounds: a recruiter phone screen, then a hiring manager interview.',
    skills: ['communication', 'sql-data'],
  },
  'best-buy-internship-guide': {
    family: 'other',
    processLine: 'Best Buy opens with a pre-recorded video interview on customer-centricity and teamwork.',
    skills: ['communication', 'quant-reasoning'],
  },
  'blackrock-internship-guide': {
    family: 'finance',
    processLine:
      "BlackRock's first step after applying is a short pre-interview video assessment you must finish within 5 days.",
    skills: ['case-structure', 'coding-fundamentals'],
  },
  'block-square-internship-guide': {
    family: 'software',
    processLine: "Block's recruiter screen is 15-30 minutes on background and motivation, after a coding assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'bmo-capital-markets-internship-guide': {
    family: 'finance',
    processLine: "BMO's first round is a 15-30 minute HireVue with behavioral and technical questions.",
    skills: ['financial-modeling', 'quant-reasoning'],
  },
  'booz-allen-hamilton-internship-guide': {
    family: 'software',
    processLine:
      'Booz Allen starts with a 30-minute recruiter screen on your resume and why Booz Allen; it is not a case round.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'booz-allen-internship-guide': {
    family: 'software',
    processLine:
      'Booz Allen starts with a 30-minute recruiter screen on your resume and why Booz Allen; it is not a case round.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'brattle-group-internship-guide': {
    family: 'consulting',
    processLine:
      'Brattle opens with a recruiter call on your interest in economic consulting and your quantitative background.',
    skills: ['sql-data', 'case-structure'],
  },
  'braze-internship-guide': {
    family: 'software',
    processLine: 'Braze starts with a 30-minute recruiter call on your background, motivations and career goals.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'bungie-internship-guide': {
    family: 'software',
    processLine: 'Bungie usually starts with a phone screen, then a one-on-one with the hiring manager.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'caesars-entertainment-internship-guide': {
    family: 'other',
    processLine: "Caesars' first round is a HireVue or 20-30 minute phone screen on motivation and customer service.",
    skills: ['communication', 'operations'],
  },
  'canva-internship-guide': {
    family: 'software',
    processLine: 'Canva kicks off with a 20-30 minute recruiter Zoom on your aspirations, experience and culture fit.',
    skills: ['ml-fundamentals', 'product-sense'],
  },
  'capital-group-internship-guide': {
    family: 'finance',
    processLine:
      'Capital Group opens with a recruiter screen on your qualifications, interests, and why Capital Group.',
    skills: ['markets', 'coding-fundamentals'],
  },
  'capital-one-internship-guide': {
    family: 'finance',
    processLine:
      'Capital One has no classic first round: after an online assessment, Power Day mixes case, technical and behavioral.',
    skills: ['case-structure', 'sql-data'],
  },
  'captech-internship-guide': {
    family: 'consulting',
    processLine: 'CapTech starts with a roughly 30-minute recruiter screen with STAR-format behavioral questions.',
    skills: ['communication', 'sql-data'],
  },
  'carnival-internship-guide': {
    family: 'other',
    processLine: 'Carnival opens with an on-demand HireVue video interview.',
    skills: ['communication', 'excel'],
  },
  'cbiz-internship-guide': {
    family: 'accounting-firm',
    processLine: 'CBIZ opens with a 15-20 minute recruiter fit check: why CBIZ, why this office, your target track.',
    skills: ['accounting', 'excel'],
  },
  'cboe-internship-guide': {
    family: 'data-analytics',
    processLine:
      "Cboe's first interview is a 30-minute video call on your experience and skills, plus technical depth for some roles.",
    skills: ['sql-data', 'markets'],
  },
  'cg-tax-audit-advisory-internship-guide': {
    family: 'accounting-firm',
    processLine: 'CG starts with a phone or video screen with the recruiting team about your background.',
    skills: ['accounting', 'tax'],
  },
  'charles-river-associates-internship-guide': {
    family: 'consulting',
    processLine: "CRA's first round is a 45-minute virtual interview: behavioral questions plus a mini economics case.",
    skills: ['case-structure', 'quant-reasoning'],
  },
  'cherry-bekaert-internship-guide': {
    family: 'accounting-firm',
    processLine: 'Cherry Bekaert starts with a 15-20 minute phone or video screen with a recruiter.',
    skills: ['accounting', 'excel'],
  },
  'citadel-internship-guide': {
    family: 'finance',
    processLine: "Citadel's first round is a 45-60 minute technical video interview, after an online assessment.",
    skills: ['sql-data', 'quant-reasoning'],
  },
  'citi-internship-guide': {
    family: 'finance',
    processLine:
      "Citi's first round is a recorded digital interview: 3-5 video questions plus a situational judgment section.",
    skills: ['coding-fundamentals', 'markets'],
  },
  'clearview-healthcare-partners-internship-guide': {
    family: 'consulting',
    processLine:
      "ClearView's case interview tests problem-solving and quantitative reasoning on a life-sciences problem.",
    skills: ['case-structure', 'market-sizing'],
  },
  'cme-group-internship-guide': {
    family: 'finance',
    processLine:
      "CME's technology track starts with a coding pre-assessment, then virtual coding and behavioral interviews.",
    skills: ['coding-fundamentals', 'markets'],
  },
  'coca-cola-internship-guide': {
    family: 'marketing',
    processLine: 'Coca-Cola starts with a recruiter call: eligibility, availability, motivation, and why Coca-Cola.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'coinbase-internship-guide': {
    family: 'software',
    processLine:
      "Coinbase's recruiter screen is 15-30 minutes on background, motivation and crypto interest, after a CodeSignal OA.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'colgate-palmolive-internship-guide': {
    family: 'marketing',
    processLine: 'Colgate starts with a behavioral recruiter screen on motivation, availability and fit.',
    skills: ['communication', 'marketing-analytics'],
  },
  'comcast-internship-guide': {
    family: 'other',
    processLine: 'Comcast opens with a one-way HireVue: 4-6 behavioral questions including why Comcast.',
    skills: ['case-structure', 'sql-data'],
  },
  'constellation-brands-internship-guide': {
    family: 'marketing',
    processLine:
      'Constellation starts with a 20-30 minute recruiter call on motivation, role fit and behavioral basics.',
    skills: ['communication', 'marketing-strategy'],
  },
  'corebridge-financial-internship-guide': {
    family: 'finance',
    processLine:
      'Corebridge starts with an HR phone screen on the role and your qualifications; actuarial candidates discuss SOA exams.',
    skills: ['financial-modeling', 'sql-data'],
  },
  'coupang-internship-guide': {
    family: 'software',
    processLine:
      "Coupang's recruiter screen is about 30 minutes on background and role fit, after a HackerRank assessment.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'cox-enterprises-internship-guide': {
    family: 'other',
    processLine: 'Cox starts with a 15-30 minute recruiter phone screen on the role and your background.',
    skills: ['sql-data', 'operations'],
  },
  'crowe-internship-guide': {
    family: 'accounting-firm',
    processLine:
      "Crowe's first interview is about 30 minutes on video, covering work history, education and activities.",
    skills: ['case-structure', 'tax'],
  },
  'datadog-internship-guide': {
    family: 'software',
    processLine:
      "Datadog's first interview is a 45-60 minute live coding session with an engineer, after a HackerRank test.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'de-shaw-internship-guide': {
    family: 'finance',
    processLine: "D.E. Shaw's first interviews test coding and CS fundamentals, after a hard HackerRank assessment.",
    skills: ['coding-fundamentals', 'quant-reasoning'],
  },
  'docusign-internship-guide': {
    family: 'software',
    processLine:
      'DocuSign starts with a roughly 30-minute recruiter screen on background, motivation and basic behavioral questions.',
    skills: ['communication', 'coding-fundamentals'],
  },
  'dollar-tree-internship-guide': {
    family: 'other',
    processLine: 'Dollar Tree likely starts with a short recruiter screen, including why discount retail.',
    skills: ['sql-data', 'product-sense'],
  },
  'dow-jones-internship-guide': {
    family: 'finance',
    processLine:
      'Dow Jones usually starts with a short phone or recruiter screen confirming the role and your background.',
    skills: ['financial-modeling', 'sql-data'],
  },
  'dreamworks-internship-guide': {
    family: 'other',
    processLine: 'DreamWorks typically runs a recruiter phone screen, then a video interview with hiring managers.',
    skills: ['consumer-insight', 'marketing-strategy'],
  },
  'duolingo-internship-guide': {
    family: 'software',
    processLine:
      "Duolingo's first live round is a 60-minute coding interview with an engineer, after a CodeSignal assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'edward-jones-internship-guide': {
    family: 'finance',
    processLine:
      'Edward Jones opens with a recorded video interview: short behavioral prompts, about 2 minutes per answer.',
    skills: ['communication', 'case-structure'],
  },
  'eisneramper-internship-guide': {
    family: 'accounting-firm',
    processLine:
      "EisnerAmper's first round is a 30-45 minute behavioral interview: why accounting, why EisnerAmper, CPA plans.",
    skills: ['accounting', 'excel'],
  },
  'electronic-arts-internship-guide': {
    family: 'software',
    processLine: 'EA opens with a recruiter call on your background, interest and logistics.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'endeavor-internship-guide': {
    family: 'other',
    processLine: 'WME runs two or more interview rounds, with questions on your entertainment industry knowledge.',
    skills: ['sql-data', 'excel'],
  },
  'estee-lauder-internship-guide': {
    family: 'marketing',
    processLine: 'Estee Lauder opens with a one-way HireVue of behavioral questions, sent right after you apply.',
    skills: ['communication', 'marketing-strategy'],
  },
  'etsy-internship-guide': {
    family: 'software',
    processLine: 'Etsy starts with a 20-30 minute recruiter call on fit and why Etsy; it is not a technical test.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'evercore-internship-guide': {
    family: 'finance',
    processLine:
      "Evercore's first round is two 30-minute interviews: behavioral plus accounting, valuation and merger-math technicals.",
    skills: ['accounting', 'valuation'],
  },
  'expedia-internship-guide': {
    family: 'software',
    processLine: 'Expedia opens with a 45-60 minute strengths-based situational judgment test, then a coding test.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'ey-internship-guide': {
    family: 'accounting-firm',
    processLine:
      "EY's first interview is a pre-recorded HireVue with 3-5 behavioral questions, after an online skills assessment.",
    skills: ['accounting', 'audit'],
  },
  'ey-parthenon-internship-guide': {
    family: 'consulting',
    processLine:
      "EY-Parthenon's first round is behavioral and case interviews with several EY-Parthenon professionals.",
    skills: ['case-structure', 'excel'],
  },
  'fanduel-internship-guide': {
    family: 'data-analytics',
    processLine:
      "FanDuel's first interview is virtual with team stakeholders on role and fit, after a recruiter and HireVue screen.",
    skills: ['communication', 'sql-data'],
  },
  'fannie-mae-internship-guide': {
    family: 'finance',
    processLine: 'Fannie Mae starts with a 30-minute behavioral phone screen with a recruiter.',
    skills: ['communication', 'quant-reasoning'],
  },
  'figma-internship-guide': {
    family: 'software',
    processLine: 'Figma starts with a 30-minute recruiter screen on your background and motivation for Figma.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'flatiron-health-internship-guide': {
    family: 'software',
    processLine:
      'Flatiron starts with a roughly 30-minute recruiter screen on your interest in healthcare tech and the mission.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'fox-corporation-internship-guide': {
    family: 'other',
    processLine: 'Fox opens with a pre-recorded video interview, then a live hiring-manager interview.',
    skills: ['excel', 'case-structure'],
  },
  'frank-rimerman-internship-guide': {
    family: 'accounting-firm',
    processLine: "Frank, Rimerman's first round is a casual recruiter conversation focused on character and fit.",
    skills: ['accounting', 'audit'],
  },
  'frazier-deeter-internship-guide': {
    family: 'accounting-firm',
    processLine: 'Frazier & Deeter interviews you with two partners, separately, then lunch with two associates.',
    skills: ['tax', 'audit'],
  },
  'freddie-mac-internship-guide': {
    family: 'finance',
    processLine: "Freddie Mac's first round is a pre-recorded video interview, not a live conversation.",
    skills: ['communication', 'sql-data'],
  },
  'ft-partners-internship-guide': {
    family: 'finance',
    processLine:
      "FT Partners' first round is virtual technical and behavioral interviews, after a mandatory cognitive assessment.",
    skills: ['valuation', 'financial-modeling'],
  },
  'fti-consulting-internship-guide': {
    family: 'consulting',
    processLine:
      'FTI starts with a pre-recorded video interview: why FTI, why this segment, and an analytical-problem story.',
    skills: ['quant-reasoning', 'excel'],
  },
  'general-mills-internship-guide': {
    family: 'marketing',
    processLine: 'General Mills runs one to two STAR-format behavioral interview rounds.',
    skills: ['communication', 'marketing-strategy'],
  },
  'greenhill-internship-guide': {
    family: 'finance',
    processLine:
      "Mizuho | Greenhill's first round is a 20-30 minute HireVue with 4-6 behavioral and motivational questions.",
    skills: ['communication', 'financial-modeling'],
  },
  'guess-internship-guide': {
    family: 'marketing',
    processLine:
      'Guess runs a phone or video screen, then a department interview; design candidates walk through a portfolio.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'guggenheim-partners-internship-guide': {
    family: 'finance',
    processLine:
      'Guggenheim opens with a 15-20 minute HireVue: two behavioral scenarios and one basic technical question.',
    skills: ['financial-modeling', 'accounting'],
  },
  'hallmark-cards-internship-guide': {
    family: 'marketing',
    processLine: 'Hallmark starts with a recruiter call, then separate manager calls of about 30 minutes each.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'hbo-internship-guide': {
    family: 'other',
    processLine: 'HBO (WBD) opens with a one-way HireVue video interview about a week after you apply.',
    skills: ['marketing-strategy', 'research'],
  },
  'health-advances-internship-guide': {
    family: 'consulting',
    processLine: "Health Advances' first round is 1-2 interviews, each a behavioral Q&A plus a healthcare case.",
    skills: ['case-structure', 'quant-reasoning'],
  },
  'hershey-internship-guide': {
    family: 'marketing',
    processLine: "Hershey's main interview is one roughly 30-minute STAR behavioral video call with two team members.",
    skills: ['communication', 'marketing-strategy'],
  },
  'hilton-internship-guide': {
    family: 'other',
    processLine: 'Hilton opens with a one-way HireVue: 5-7 behavioral questions, 3 minutes to answer each.',
    skills: ['communication', 'sql-data'],
  },
  'hormel-foods-internship-guide': {
    family: 'marketing',
    processLine: 'Hormel starts with a 30-minute recruiter phone screen of 4-5 STAR behavioral questions.',
    skills: ['communication', 'marketing-strategy'],
  },
  'houlihan-lokey-internship-guide': {
    family: 'finance',
    processLine:
      "Houlihan Lokey's first interview is a 30-minute phone screen on basic fit, after a cognitive and personality test.",
    skills: ['financial-modeling', 'markets'],
  },
  'hsbc-internship-guide': {
    family: 'finance',
    processLine:
      'HSBC starts with an immersive assessment: 60-90 minutes of scenario-based videos with written and selection answers.',
    skills: ['financial-modeling', 'markets'],
  },
  'huron-consulting-group-internship-guide': {
    family: 'consulting',
    processLine: "Huron's first round is one 30-60 minute interviewer-led case, after a short recruiter screen.",
    skills: ['case-structure', 'sql-data'],
  },
  'hyatt-internship-guide': {
    family: 'other',
    processLine: 'Hyatt starts with a recruiter conversation on motivation, availability and hospitality interest.',
    skills: ['sql-data', 'case-structure'],
  },
  'instacart-internship-guide': {
    family: 'software',
    processLine:
      "Instacart's recruiter screen is 30 minutes on background and motivation, after a CodeSignal assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'interpublic-internship-guide': {
    family: 'marketing',
    processLine: null,
    skills: ['marketing-strategy', 'marketing-analytics'],
  },
  'jefferies-internship-guide': {
    family: 'finance',
    processLine: "Jefferies' first round is a 20-30 minute phone or HireVue interview with analysts or associates.",
    skills: ['valuation', 'financial-modeling'],
  },
  'john-deere-internship-guide': {
    family: 'software',
    processLine:
      "John Deere's first conversation is an HR phone screen; IT/SWE roles take a HackerRank assessment first.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'jpmorgan-internship-guide': {
    family: 'finance',
    processLine: "JPMorgan's first round is a HireVue video interview with 3-5 mostly behavioral questions.",
    skills: ['communication', 'sql-data'],
  },
  'jump-trading-internship-guide': {
    family: 'finance',
    processLine: "Jump's first rounds are 45-60 minute live coding interviews focused on C++ and algorithms.",
    skills: ['coding-fundamentals', 'statistics'],
  },
  'kearney-internship-guide': {
    family: 'consulting',
    processLine: "Kearney's first round is two 45-minute sessions: one case interview and one behavioral.",
    skills: ['case-structure', 'operations'],
  },
  'kellanova-internship-guide': {
    family: 'marketing',
    processLine: 'Kellanova starts with a recruiter screen: fit, why Kellanova, and a resume walk-through.',
    skills: ['consumer-insight', 'marketing-analytics'],
  },
  'kenvue-internship-guide': {
    family: 'marketing',
    processLine: 'Kenvue runs 2-5 behavioral-heavy rounds, possibly including a HireVue-style digital interview.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'klarna-internship-guide': {
    family: 'software',
    processLine:
      'Klarna starts with a 30-minute recruiter call on background and motivation, light on technical content.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'kohls-internship-guide': {
    family: 'other',
    processLine: "Kohl's first round is a virtual screening interview, then a final virtual interview 1-2 weeks later.",
    skills: ['case-structure', 'quant-reasoning'],
  },
  'komodo-health-internship-guide': {
    family: 'data-analytics',
    processLine:
      'Komodo Health starts with a roughly 30-minute recruiter screen on motivation, mission fit and your tech stack.',
    skills: ['sql-data', 'statistics'],
  },
  'kpmg-internship-guide': {
    family: 'accounting-firm',
    processLine: "KPMG's first step is an online assessment, usually a recorded or live behavioral video.",
    skills: ['accounting', 'excel'],
  },
  'kraft-heinz-internship-guide': {
    family: 'other',
    processLine:
      "Kraft Heinz's first interview is a recorded HireVue of 4-6 behavioral questions, after Pymetrics games.",
    skills: ['communication', 'sql-data'],
  },
  'kroger-internship-guide': {
    family: 'other',
    processLine: 'Kroger opens with a 20-30 minute one-way HireVue of behavioral questions mapped to its values.',
    skills: ['communication', 'sql-data'],
  },
  'l-e-k-consulting-internship-guide': {
    family: 'consulting',
    processLine:
      "L.E.K.'s first round is 2-3 thirty-minute interviews, each blending brief behavioral questions with a case.",
    skills: ['case-structure', 'market-sizing'],
  },
  'land-olakes-internship-guide': {
    family: 'other',
    processLine: "Land O'Lakes starts with a 30-45 minute call on your background and why food and agriculture.",
    skills: ['communication', 'operations'],
  },
  'las-vegas-sands-internship-guide': {
    family: 'other',
    processLine: 'Las Vegas Sands interviews focus on teamwork, communication and your interest in integrated resorts.',
    skills: ['case-structure', 'quant-reasoning'],
  },
  'lionsgate-internship-guide': {
    family: 'other',
    processLine:
      'Lionsgate opens with a pre-recorded video: 5-8 behavioral questions on motivation, goals and deadlines.',
    skills: ['communication', 'research'],
  },
  'live-nation-internship-guide': {
    family: 'other',
    processLine:
      'Live Nation starts with a HireVue or a 20-30 minute recruiter call of straightforward behavioral questions.',
    skills: ['communication', 'sql-data'],
  },
  'loreal-internship-guide': {
    family: 'marketing',
    processLine:
      "L'Oreal's first interview is a recorded HireVue, after an aptitude assessment that cuts most applicants.",
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'lululemon-internship-guide': {
    family: 'marketing',
    processLine: 'Lululemon starts with an HR screening call: why lululemon and how you live its IDEA values.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'marcum-internship-guide': {
    family: 'accounting-firm',
    processLine:
      "Marcum's first round is a casual chat with two staff members about your background and why public accounting.",
    skills: ['accounting', 'excel'],
  },
  'marriott-internship-guide': {
    family: 'other',
    processLine: 'Marriott opens with a one-way HireVue of about 5 questions tied to its core values.',
    skills: ['operations', 'consumer-insight'],
  },
  'mars-internship-guide': {
    family: 'other',
    processLine: 'Mars opens with a HireVue: 2-5 recorded behavioral questions, 2 minutes each, STAR recommended.',
    skills: ['communication', 'sql-data'],
  },
  'mastercard-internship-guide': {
    family: 'software',
    processLine: 'Mastercard starts with a 15-30 minute recruiter screen on your interest in Mastercard and payments.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'mccann-internship-guide': {
    family: 'marketing',
    processLine: 'McCann starts with a recruiter screen, then discipline-specific team interviews.',
    skills: ['marketing-strategy', 'research'],
  },
  'merck-internship-guide': {
    family: 'other',
    processLine: 'Merck starts with a 15-30 minute recruiter screen: why Merck and why this role.',
    skills: ['sql-data', 'case-structure'],
  },
  'mercor-internship-guide': {
    family: 'software',
    processLine: 'Mercor opens with a 20-minute AI interview on your resume, projects and technical decisions.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'meta-internship-guide': {
    family: 'software',
    processLine: 'Meta starts with a short recruiter conversation on background and fit.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'mgm-resorts-internship-guide': {
    family: 'other',
    processLine: 'MGM starts with an HR screen on motivation, guest-service orientation, and why MGM.',
    skills: ['case-structure', 'sql-data'],
  },
  'michaels-stores-internship-guide': {
    family: 'other',
    processLine:
      'Michaels starts with a talent-team screen on motivation, interest in creative retail, and department fit.',
    skills: ['sql-data', 'marketing-strategy'],
  },
  'mlb-internship-guide': {
    family: 'other',
    processLine: 'MLB starts with a 15-30 minute HR screen: why MLB, availability, and teamwork questions.',
    skills: ['sql-data', 'excel'],
  },
  'moelis-internship-guide': {
    family: 'finance',
    processLine: "Moelis' first round is a 30-minute phone or Zoom interview, after the Suited assessment.",
    skills: ['financial-modeling', 'valuation'],
  },
  'mongodb-internship-guide': {
    family: 'software',
    processLine: 'MongoDB starts with a 30-minute recruiter screen on your background, skills and why MongoDB.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'nba-internship-guide': {
    family: 'other',
    processLine: 'The NBA starts with a one-way video interview for the most qualified applicants.',
    skills: ['operations', 'sql-data'],
  },
  'nextdoor-internship-guide': {
    family: 'software',
    processLine: 'Nextdoor starts with a 20-30 minute recruiter call on motivation, your resume and logistics.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'nordstrom-internship-guide': {
    family: 'other',
    processLine: 'Nordstrom opens with a HireVue of behavioral and motivational questions.',
    skills: ['communication', 'product-sense'],
  },
  'norwegian-cruise-line-internship-guide': {
    family: 'marketing',
    processLine:
      'Norwegian starts with a recruiter phone screen on motivation, brand knowledge and the cruise industry.',
    skills: ['marketing-strategy', 'marketing-analytics'],
  },
  'notion-internship-guide': {
    family: 'software',
    processLine: 'Notion starts with a 30-60 minute recruiter screen: why Notion and what draws you to the track.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'optiver-internship-guide': {
    family: 'finance',
    processLine:
      "Optiver's first interview is a 45-60 minute phone or video session, after a five-part online assessment.",
    skills: ['quant-reasoning', 'coding-fundamentals'],
  },
  'oura-internship-guide': {
    family: 'software',
    processLine:
      'Oura starts with a get-to-know-you recruiter conversation on your background, motivation and mission fit.',
    skills: ['ml-fundamentals', 'coding-fundamentals'],
  },
  'p-and-g-internship-guide': {
    family: 'marketing',
    processLine: 'P&G interviews are 45-60 minute behavioral STAR rounds, only after you pass two online assessments.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'palo-alto-networks-internship-guide': {
    family: 'software',
    processLine:
      'Palo Alto Networks starts with a 20-30 minute recruiter screen, including light Python, networking and cloud questions.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'paypal-internship-guide': {
    family: 'software',
    processLine: 'PayPal starts with a 30-minute recruiter screen on background and your interest in fintech.',
    skills: ['sql-data', 'coding-fundamentals'],
  },
  'pepsico-internship-guide': {
    family: 'other',
    processLine:
      "PepsiCo's first live interview is a recruiter phone or video screen with STAR questions on its GREAT5 principles.",
    skills: ['sql-data', 'case-structure'],
  },
  'pjt-partners-internship-guide': {
    family: 'finance',
    processLine: "PJT's first round is a 30-minute phone or video screen, about half of it behavioral.",
    skills: ['valuation', 'financial-modeling'],
  },
  'pkf-oconnor-davies-internship-guide': {
    family: 'accounting-firm',
    processLine:
      "PKF O'Connor Davies interviews you with a manager, senior manager or partner about your past experience.",
    skills: ['audit', 'accounting'],
  },
  'plante-moran-internship-guide': {
    family: 'accounting-firm',
    processLine:
      'Plante Moran starts with a recruiter phone interview; there is no online assessment or technical test.',
    skills: ['tax', 'accounting'],
  },
  'point72-internship-guide': {
    family: 'finance',
    processLine: 'Point72 Academy has you submit a stock pitch on a mid-cap stock after a Wonderlic cognitive test.',
    skills: ['sql-data', 'financial-modeling'],
  },
  'publix-internship-guide': {
    family: 'operations',
    processLine: 'Publix interviews by panel, mostly behavioral with some general technical questions.',
    skills: ['operations', 'excel'],
  },
  'pvh-internship-guide': {
    family: 'marketing',
    processLine: 'PVH starts with a virtual recruiter screen on your background, track fit and availability.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'qvc-internship-guide': {
    family: 'marketing',
    processLine: 'QVC starts with a 10-15 minute recruiter call: how you found QVC and what you know about it.',
    skills: ['marketing-strategy', 'marketing-analytics'],
  },
  'raymond-james-internship-guide': {
    family: 'finance',
    processLine:
      'Raymond James opens with a HireVue: four video answers plus a written essay analyzing financial data.',
    skills: ['communication', 'financial-modeling'],
  },
  'rbc-capital-markets-internship-guide': {
    family: 'finance',
    processLine: "RBC's first round is a 60-minute phone or video interview with one or two analysts, after a HireVue.",
    skills: ['valuation', 'financial-modeling'],
  },
  'recursion-internship-guide': {
    family: 'ai-ml',
    processLine:
      "Recursion's interviews reportedly cover mission fit, a technical or project discussion, and a cross-functional chat.",
    skills: ['coding-fundamentals', 'statistics'],
  },
  'reddit-internship-guide': {
    family: 'software',
    processLine: 'Reddit starts with a brief recruiter call on eligibility, timeline and mutual interest.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'robert-w-baird-internship-guide': {
    family: 'finance',
    processLine:
      "Baird's first round is a 30-minute phone or campus interview mixing behavioral and general technical questions.",
    skills: ['financial-modeling', 'accounting'],
  },
  'robinhood-internship-guide': {
    family: 'software',
    processLine:
      "Robinhood's recruiter screen is 30 minutes of basic behavioral questions, after a CodeSignal assessment.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'rothschild-and-co-internship-guide': {
    family: 'finance',
    processLine:
      "Rothschild's first round is a 30-minute phone or HireVue interview: resume walkthrough and competency questions.",
    skills: ['financial-modeling', 'accounting'],
  },
  'royal-caribbean-internship-guide': {
    family: 'other',
    processLine: 'Royal Caribbean opens with a HireVue of 3-5 behavioral and situational questions.',
    skills: ['communication', 'sql-data'],
  },
  'rsm-internship-guide': {
    family: 'accounting-firm',
    processLine: "RSM's main interview is about 30 minutes: career goals, why RSM, and why your service line.",
    skills: ['communication', 'accounting'],
  },
  'salesforce-internship-guide': {
    family: 'software',
    processLine:
      "Salesforce's recruiter screen is 30 minutes on background and motivation, after a coding OA for engineers.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'sallie-mae-internship-guide': {
    family: 'data-analytics',
    processLine: 'Sallie Mae starts with a 20-30 minute HR phone screen on motivation, fit, and why student lending.',
    skills: ['sql-data', 'quant-reasoning'],
  },
  'scale-ai-internship-guide': {
    family: 'ai-ml',
    processLine:
      "Scale AI starts with a roughly 30-minute recruiter call on your background and the team you're targeting.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'servicenow-internship-guide': {
    family: 'software',
    processLine:
      "ServiceNow's recruiter screen is 20-30 minutes on background and motivation, after a HackerRank test.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'shopify-internship-guide': {
    family: 'software',
    processLine:
      "Shopify's first interview is the Life Story round: 45-60 minutes walking through your life chronologically.",
    skills: ['communication', 'ml-fundamentals'],
  },
  'skechers-internship-guide': {
    family: 'marketing',
    processLine: 'Skechers starts with an HR phone or video screen on your background and department fit.',
    skills: ['marketing-strategy', 'marketing-analytics'],
  },
  'smucker-internship-guide': {
    family: 'marketing',
    processLine: 'Smucker starts with an HR phone or video screen on your background and interest in CPG.',
    skills: ['consumer-insight', 'marketing-strategy'],
  },
  'snap-internship-guide': {
    family: 'software',
    processLine: 'Snap starts with a 20-30 minute recruiter screen on your background and motivation.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'snowflake-internship-guide': {
    family: 'software',
    processLine:
      'Snowflake starts with a 30-minute recruiter screen with a high-level technical overview but no deep coding.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'sofi-internship-guide': {
    family: 'software',
    processLine:
      'SoFi starts with a 20-30 minute recruiter call on logistics, motivation and basic technical competency.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'sony-internship-guide': {
    family: 'software',
    processLine: "Sony's first round is a 15-30 minute recruiter call or recorded video, depending on the division.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'sothebys-internship-guide': {
    family: 'marketing',
    processLine:
      "Sotheby's starts with a 20-30 minute HR call: why Sotheby's, why this department, and your passion for art.",
    skills: ['communication', 'marketing-strategy'],
  },
  'spaulding-ridge-internship-guide': {
    family: 'data-analytics',
    processLine: 'Spaulding Ridge starts with a roughly 30-minute recruiter call on your background and motivation.',
    skills: ['sql-data', 'coding-fundamentals'],
  },
  'splunk-internship-guide': {
    family: 'software',
    processLine: 'Splunk starts with a 15-30 minute recruiter screen, then a Karat technical assessment.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'spotify-internship-guide': {
    family: 'other',
    processLine: 'Spotify starts with a recruiter call, then a technical or craft interview.',
    skills: ['sql-data', 'quant-reasoning'],
  },
  'stax-internship-guide': {
    family: 'consulting',
    processLine: 'Stax starts with a 20-30 minute HR screen: why consulting, why Stax, and its PE focus.',
    skills: ['market-sizing', 'sql-data'],
  },
  'stepstone-group-internship-guide': {
    family: 'finance',
    processLine:
      'StepStone opens with a 20-30 minute recruiter call on your background and interest in private markets.',
    skills: ['financial-modeling', 'excel'],
  },
  'stifel-internship-guide': {
    family: 'finance',
    processLine:
      'Stifel starts with a HireVue: about 5 behavioral questions plus timed games on mental math and patterns.',
    skills: ['quant-reasoning', 'financial-modeling'],
  },
  'susquehanna-sig-internship-guide': {
    family: 'finance',
    processLine: "SIG's phone screen covers your background and why SIG, after a 20-minute quantitative evaluation.",
    skills: ['quant-reasoning', 'statistics'],
  },
  't-rowe-price-internship-guide': {
    family: 'finance',
    processLine: "T. Rowe Price's first round is a roughly 45-minute asynchronous HireVue video assessment.",
    skills: ['financial-modeling', 'sql-data'],
  },
  'target-internship-guide': {
    family: 'other',
    processLine: 'Target opens with a HireVue: three to five recorded behavioral questions.',
    skills: ['communication', 'sql-data'],
  },
  'tbwa-internship-guide': {
    family: 'marketing',
    processLine: 'TBWA starts with a recruiter conversation on suitability, motivation and culture fit.',
    skills: ['marketing-strategy', 'research'],
  },
  'the-carlyle-group-internship-guide': {
    family: 'finance',
    processLine: "Carlyle's first round is a 30-minute video or phone screen with a recruiter or team member.",
    skills: ['financial-modeling', 'valuation'],
  },
  'tjx-companies-internship-guide': {
    family: 'other',
    processLine: 'TJX opens with a HireVue of about five questions, including one where you allocate product.',
    skills: ['communication', 'sql-data'],
  },
  'tower-research-capital-internship-guide': {
    family: 'finance',
    processLine:
      "Tower's technical interviews test programming, quantitative reasoning and CS fundamentals, after a 90-minute OA.",
    skills: ['coding-fundamentals', 'quant-reasoning'],
  },
  'tpg-internship-guide': {
    family: 'finance',
    processLine:
      "TPG's first round is a 30-45 minute call: resume, why TPG, and technical warm-ups on LBOs and accounting.",
    skills: ['accounting', 'financial-modeling'],
  },
  'trinity-life-sciences-internship-guide': {
    family: 'consulting',
    processLine:
      "Trinity's first round pairs values-based behavioral questions with a life-sciences commercial strategy case.",
    skills: ['case-structure', 'quant-reasoning'],
  },
  'two-sigma-internship-guide': {
    family: 'finance',
    processLine:
      'Two Sigma opens with a technical screen: a coding assessment for SWE or a probability phone screen for QR.',
    skills: ['coding-fundamentals', 'quant-reasoning'],
  },
  'ulta-beauty-internship-guide': {
    family: 'marketing',
    processLine: 'Ulta opens with an on-demand video screen: why Ulta, why DREAM, and high-level behavioral questions.',
    skills: ['communication', 'marketing-strategy'],
  },
  'vaynermedia-internship-guide': {
    family: 'marketing',
    processLine:
      'VaynerMedia starts with a recruiter screen on your background and interest in social and advertising.',
    skills: ['research', 'marketing-strategy'],
  },
  'virtu-financial-internship-guide': {
    family: 'finance',
    processLine: "Virtu's HR phone screen covers motivation plus one brainteaser, after a HackerRank assessment.",
    skills: ['coding-fundamentals', 'quant-reasoning'],
  },
  'visa-internship-guide': {
    family: 'software',
    processLine: "Visa's recruiter screen is 15-30 minutes, after a four-question CodeSignal assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'voya-financial-internship-guide': {
    family: 'finance',
    processLine: 'Voya starts with a brief recruiter phone call confirming your background and interest.',
    skills: ['sql-data', 'quant-reasoning'],
  },
  'walmart-internship-guide': {
    family: 'other',
    processLine:
      'Walmart starts with an online assessment: a judgment test for corporate roles or HackerRank for tech.',
    skills: ['sql-data', 'operations'],
  },
  'warburg-pincus-internship-guide': {
    family: 'finance',
    processLine: "Warburg Pincus' first round is two 30-minute virtual interviews with VPs or Principals.",
    skills: ['communication', 'financial-modeling'],
  },
  'wellington-management-internship-guide': {
    family: 'finance',
    processLine: 'Wellington opens with a conversational, non-technical HR phone screen on your background and goals.',
    skills: ['case-structure', 'financial-modeling'],
  },
  'west-monroe-internship-guide': {
    family: 'consulting',
    processLine:
      "West Monroe's loop is virtual or in person, built around a case round plus values-based behavioral questions.",
    skills: ['case-structure', 'sql-data'],
  },
  'whirlpool-internship-guide': {
    family: 'operations',
    processLine:
      "Whirlpool's first interview is a recruiter phone screen or group panel, after a mandatory online assessment.",
    skills: ['case-structure', 'operations'],
  },
  'wieden-kennedy-internship-guide': {
    family: 'marketing',
    processLine: 'W+K starts with a recruiter screen, then a hiring-manager interview: why advertising, why W+K.',
    skills: ['consumer-insight', 'marketing-strategy'],
  },
  'william-blair-internship-guide': {
    family: 'finance',
    processLine:
      'William Blair opens with a 20-30 minute HireVue, mostly behavioral: why banking, why William Blair, teamwork.',
    skills: ['financial-modeling', 'accounting'],
  },
  'wipfli-internship-guide': {
    family: 'accounting-firm',
    processLine: 'Wipfli starts with a 15-minute phone screen on behavioral questions and your fit with the firm.',
    skills: ['communication', 'tax'],
  },
  'wolverine-trading-internship-guide': {
    family: 'finance',
    processLine: 'Wolverine starts with a 15-20 minute recruiter phone screen.',
    skills: ['statistics', 'sql-data'],
  },
  'workday-internship-guide': {
    family: 'software',
    processLine: "Workday's recruiter screen is 30 minutes on background and why Workday, after a HackerRank OA.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'world-bank-internship-guide': {
    family: 'other',
    processLine:
      'World Bank Pioneers interviews come after a timed Coderbyte multiple-choice assessment, with the hiring unit.',
    skills: ['sql-data', 'quant-reasoning'],
  },
  'yhb-internship-guide': {
    family: 'accounting-firm',
    processLine: "YHB's first round is a recruiter screen focused on getting to know your traits and work style.",
    skills: ['accounting', 'case-structure'],
  },
  'zs-associates-internship-guide': {
    family: 'consulting',
    processLine: 'ZS runs candidate-led case and behavioral interviews after a timed aptitude test.',
    skills: ['case-structure', 'sql-data'],
  },
};
